import { useEffect, useRef, useState, RefObject } from 'react';

interface UseInViewOptions {
   rootMargin?: string;
   once?: boolean;
}

export function useInView<T extends HTMLElement = HTMLDivElement>(
   options: UseInViewOptions = {}
): [RefObject<T | null>, boolean] {   // ← T | null here
   const { rootMargin = '200px', once = false } = options;
   const ref         = useRef<T>(null);
   const [inView, setInView] = useState(false);
   
   useEffect(() => {
      const el = ref.current;
      if (!el) return;
      
      const observer = new IntersectionObserver(
         ([entry]) => {
            if (entry.isIntersecting) {
               setInView(true);
               if (once) observer.disconnect();
            } else if (!once) {
               setInView(false);
            }
         },
         { rootMargin }
      );
      
      observer.observe(el);
      return () => observer.disconnect();
   }, [rootMargin, once]);

   return [ref, inView];
}